// extracted by mini-css-extract-plugin
export var footer = "_pd-0";
export var inherit = "_pd-1";
export var input = "_pd-2";
export var modalContent = "_pd-3";
export var quillEditor = "_pd-4";
export var subtitle = "_pd-5";